import { WEB_ROUTES } from '~/utils/webConfig';
import { NOT_UNIQUE, BIOMETRY_EXPIRED } from '~/utils/errors';

export const LANG = {
  RU: 'ru',
  KG: 'kg',
};

export const REFRESH_RATE_MS = 1000;
export const TIMEOUT_SEC = 60;

export const BIOMETRY_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  FAILED: 'failed',
  DECLINED: 'declined',
  EXPIRED: 'expired',
  CANCELED: 'canceled',
};

export const BIOMETRY_ROUTES = {
  [BIOMETRY_STATUS.ACTIVE]: WEB_ROUTES.PROFILE_BIOMETRY_EDIT,
  [BIOMETRY_STATUS.PENDING]: WEB_ROUTES.PROFILE_BIOMETRY_LOADING,
  [BIOMETRY_STATUS.FAILED]: WEB_ROUTES.PROFILE_BIOMETRY_LOADING,
  [BIOMETRY_STATUS.DECLINED]: WEB_ROUTES.PROFILE_BIOMETRY,
  [BIOMETRY_STATUS.EXPIRED]: WEB_ROUTES.PROFILE_BIOMETRY,
  [BIOMETRY_STATUS.CANCELED]: WEB_ROUTES.PROFILE_BIOMETRY,
};

export function displayData(payload = {}, findKey = '') {
  const result = payload && payload.find(item => item.value === findKey);
  if (result) {
    return result.label;
  }
  return findKey;
}

export const isNotUniqueError = (payload = []) => {
  return Boolean(payload.find(item => item.status === NOT_UNIQUE));
};

export const isBiometryExpired = (payload = []) => {
  return Boolean(payload.find(item => item.status === BIOMETRY_EXPIRED));
};

export const MESSAGE_KEY = {
  PHONE: 'phone',
  EMAIL: 'email',
};

export const ERROR_KEY = {
  PHONE: 'profile-edit-page.phone-error',
  SMS: 'profile-edit-page.sms-error',
  EMAIL: 'profile-edit-page.email-error',
  CODE: 'profile-edit-page.code-error',
};
